import { EnumSchema } from '../metadata-schema';

export const Interventielaag: EnumSchema = {
	"type": "string",
	"title": "Interventielaag",
	"enum": [
		"Goede aanwezigheid",
		"Beginnend verzuim",
		"Aanhoudend verzuim"
	]
};
